import { EconomicSubjectVatType } from "@core/schema/EconomicSubjectVatType.js";
import { SubscriptionDeliveryCount } from "@core/schema/SubscriptionDeliveryCount.js";
import { SubscriptionFrequency } from "@core/schema/SubscriptionFrequency.js";
import { SubscriptionKind } from "@core/schema/SubscriptionKind.js";
import { SubscriptionSelection } from "@core/schema/SubscriptionSelection.js";
import { SubscriptionSize } from "@core/schema/SubscriptionSize.js";
import { SubscriptionVariant } from "@core/schema/SubscriptionVariant.js";
import { country } from "@core/schema/utils/country.js";
import { CartStep } from "./CartStep.js";
import type { CartState } from "./CartType.js";

export function createInitialCart(): CartState {
	return {
		idempotencyKey: crypto.randomUUID(),
		productsInOrder: [],
		subscription: {
			size: SubscriptionSize.G250,
			variant: SubscriptionVariant.Espresso,
			frequency: SubscriptionFrequency.Weeks2,
			kind: SubscriptionKind.Recurring,
			selection: SubscriptionSelection.Cafeina,
			startsAt: "",
		},
		giftData: {
			deliveryCount: SubscriptionDeliveryCount.Deliveries3,
			spoilByEmail: true,
			donorName: "",
			donorEmail: "",
			name: "",
			email: "",
			phoneNumber: "",
		},
		activateGiftImmediately: false,
		hasSubscription: false,
		step: CartStep.PaymentDelivery,
		order: {
			products: [],
			payment: {},
			deliveryAddress: {
				country: country("Czechia"),
			},
			subjectVatType: EconomicSubjectVatType.NotVatSubject,
		},
		subscriptionModalStep: 0,
	};
}
